const getAuthHeaderJwt = (token) => {
  const forToken = token ? token : localStorage.getItem('token')
  return { Authorization: 'jwt ' + forToken }
}

export default getAuthHeaderJwt
